import type { HTMLAttributes, ReactNode } from 'react';
import { styled } from 'styled-components';

export interface PopupButtonProps extends HTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
}

export function PopupButton({ children, ...props }: PopupButtonProps) {
    return <StyledPopupButton {...props}>{children}</StyledPopupButton>;
}

const StyledPopupButton = styled.button`
    display: none;
    position: fixed;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    transform: rotate(270deg) translate(100%, -50%);
    transform-origin: right;
    inset: 50% -3px auto auto;
    margin: 0;
    z-index: 999;
    color: white;
    border: none;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(115deg, #d77c09 0%, #ff9a1e 35%, #ff9a1e);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow:
        0 2px 2px 0 rgb(0 0 0 / 14%),
        0 3px 1px -2px rgb(0 0 0 / 12%),
        0 1px 5px 0 rgb(0 0 0 / 20%);

    ${(props) => props.theme.mediaQueries.small} {
        display: block;
    }

    &:hover {
        right: 0;
        box-shadow:
            0 4px 5px 0 rgb(0 0 0 / 14%),
            0 1px 10px 0 rgb(0 0 0 / 12%),
            0 2px 4px -1px rgb(0 0 0 / 20%);
    }

    &:focus {
        outline: none;
        right: 0;
        box-shadow:
            rgb(255 255 255) 0 0 0 2px,
            0 0 0 4px ${(props) => props.theme.colors.blue500};
        border-color: ${(props) => props.theme.colors.blue500};
    }

    &:focus:not(:focus-visible) {
        outline: none;
        box-shadow: none;
    }
`;
